import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "redux/axios";

const initialState = {
  loading: false,
  isLoading: sessionStorage.getItem("success") ? true : false,
  // isLoading: localStorage.getItem("success") ? true : false,
};

export const register = createAsyncThunk(
  "account/sign-up",
  async (params, { rejectWithValue }) => {
    try {
      return await instance.post("userRegister", params);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const registerResend = createAsyncThunk(
  "account/register/resend",
  async (params, { rejectWithValue }) => {
    try {
      return await instance.post("userRegister", params);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const login = createAsyncThunk(
  "account/login",
  async (params, { rejectWithValue }) => {
    try {
      return await instance.post("login", params);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const redeemCode = createAsyncThunk(
  "account/reedm/code",
  async (params, { rejectWithValue }) => {
    try {
      return await instance.post("check_redeem_code", params);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const otpVerify = createAsyncThunk(
  "account/otp",
  async (params, { rejectWithValue }) => {
    try {
      return await instance.post("otpVerify", params);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);
export const otpForgotVerify = createAsyncThunk(
  "account/otp/forgot",
  async (params, { rejectWithValue }) => {
    try {
      return await instance.post("forgot_otp_verify", params);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const checkoutSuccess = createAsyncThunk(
  "account/checkout/success",
  async (params, { rejectWithValue }) => {
    console.log("params", params);
    try {
      return await instance.post("add_check_outId", params);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const againSendOTP = createAsyncThunk(
  "account/again/OTP",
  async (params, { rejectWithValue }) => {
    console.log("params", params);
    try {
      return await instance.post("add_check_outId", params);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const ResetPassword = createAsyncThunk(
  "account/reset/password",
  async (params, { rejectWithValue }) => {
    console.log("params", params);
    try {
      return await instance.post("resetPassword", params);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);
export const ForgotPassword = createAsyncThunk(
  "account/forgot/password",
  async (params, { rejectWithValue }) => {
    console.log("params", params);
    try {
      return await instance.post("forgotPassword", params);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const forgotResend = createAsyncThunk(
  "account/forgot/resent",
  async (params, { rejectWithValue }) => {
    console.log("params", params);
    try {
      return await instance.post("forgotPassword", params);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const firebaseLogin = createAsyncThunk(
  "socialLogin/firebase",
  async (params, { rejectWithValue }) => {
    try {
      return await instance.post("socialLogin", params);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

const sessionSlice = createSlice({
  name: "session",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(register.pending, (state) => {
        state.loading = true;
        state.isLoading = false;
      })
      .addCase(register.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.isLoading = true;
      })
      .addCase(register.rejected, (state) => {
        state.loading = false;
        state.isLoading = false;
      })
      .addCase(ForgotPassword.pending, (state) => {
        state.loading = true;
        state.isLoading = false;
      })
      .addCase(ForgotPassword.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.isLoading = true;
      })
      .addCase(ForgotPassword.rejected, (state) => {
        state.loading = false;
        state.isLoading = false;
      })
      .addCase(forgotResend.pending, (state) => {
        state.loading = true;
      })
      .addCase(forgotResend.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(forgotResend.rejected, (state) => {
        state.loading = false;
      })
      .addCase(otpVerify.pending, (state) => {
        state.loading = true;
      })
      .addCase(otpVerify.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(otpVerify.rejected, (state) => {
        state.loading = false;
      })
      .addCase(redeemCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(redeemCode.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(redeemCode.rejected, (state) => {
        state.loading = false;
      })
      .addCase(firebaseLogin.pending, (state) => {
        state.loading = true;
        state.isLoading = false;
      })
      .addCase(firebaseLogin.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.isLoading = true;
      })
      .addCase(firebaseLogin.rejected, (state) => {
        state.loading = false;
        state.isLoading = false;
      })
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.isLoading = false;
      })
      .addCase(login.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.isLoading = true;
      })
      .addCase(login.rejected, (state) => {
        state.loading = false;
        state.isLoading = false;
      });
  },
});

export default sessionSlice.reducer;
